import { format, parse } from 'date-fns';

interface DateFormat {
    separator: string;
    dateFormat: string;
}

export const validateDate = (date: string, language: string): boolean => {
    switch (language) {
        case 'de':
            return /^(((0[1-9]|1[0-9]|2[0-8])\.(0[1-9]|1[012]))|((29|30|31)\.(0[13578]|1[02]))|((29|30)\.(0[4,6,9]|11)))\.[\d]{1,4}$|^29\.02\.([\d]{1,4})(00|04|08|12|16|20|24|28|32|36|40|44|48|52|56|60|64|68|72|76|80|84|88|92|96)$/.test(
                date
            );
        default:
            return /^(((0[1-9]|1[0-9]|2[0-8])\/(0[1-9]|1[012]))|((29|30|31)\/(0[13578]|1[02]))|((29|30)\/(0[4,6,9]|11)))\/[\d]{1,4}$|^29\/02\/([\d]{1,4})(00|04|08|12|16|20|24|28|32|36|40|44|48|52|56|60|64|68|72|76|80|84|88|92|96)$/.test(
                date
            );
    }
};

export const getDateFormat = (language: string): DateFormat => {
    switch (language) {
        case 'de':
            return {
                separator: '.',
                dateFormat: 'dd.MM.yyyy'
            };
        default:
            return {
                separator: '/',
                dateFormat: 'dd/MM/yyyy'
            };
    }
};

export const formatDate = (date: string, previousLanguage: string, currentLanguage: string): string => {
    const previousLanguageFormat = getDateFormat(previousLanguage).dateFormat;
    const currentLanguageFormat = getDateFormat(currentLanguage).dateFormat;

    try {
        return format(parse(date, previousLanguageFormat, new Date()), currentLanguageFormat);
    } catch (error) {
        return date;
    }
};

export const formatDateToISOFormat = (releaseDate: string, language: string): string => {
    if (!releaseDate) {
        return '';
    }
    const dateSeparator = getDateFormat(language).separator;
    const dateParts = releaseDate.split(dateSeparator);

    if (dateParts.length !== 3) {
        // in case release date has different separators, return the release date as is
        return releaseDate;
    } else {
        // backend expects 'yyyy-mm-dd' as release date
        return `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
    }
};
